import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useParams } from "react-router-dom";
import Form  from '../common/Form';
import { post } from '../../utils/api';

const NewPass = () => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const params = useParams();
	const [ email, setEmail ] = useState(params.email ? params.email : '');
	const [ code, setCode ] = useState(params.code ? params.code : '');
	const [ disabled, setDisabled ] = useState(true);
	const [ isLoading, setIsLoading ] = useState(false);
	const [ error, setError ] = useState('');
	const [ success, setSuccess ] = useState('');

	useEffect(() => {
		setDisabled(!(email && code));
	}, [ email, code ]);

	const onSubmit = async () => {
		setIsLoading(true);
        setError('');
		setSuccess('');
		const result = await post('/newpass', { email, code, lang });
		if(result.error) {
			setError(result.error);
		} else {
			setSuccess('newpass.success');
		}
        setIsLoading(false);
	};

	return (
		<div>
	    	<h1>{t('newpass.title')}</h1>
			{isLoading ? <span>{t('common.loading')}</span> :
			<React.Fragment>
				{success ? <p>{t(success)}</p> :
				<Form error={t(error)} info={t('newpass.subtitle')}>
					<label htmlFor='email'>{t('newpass.email')}</label>
					<input
						id='email'
						type='text'
						value={email}
						onChange={e => setEmail(e.target.value)}
					/>
					<label htmlFor='code'>{t('newpass.code')}</label>
					<input
						id='code'
						type='text'
						value={code}
						onChange={e => setCode(e.target.value)}
					/>
					<input
						id='submit'
						type='submit'
						value={t('newpass.submit')}
						disabled={disabled}
						onClick={onSubmit}
					/>
				</Form>}
				<NavLink to={email ? '/cabinet/login/email/' + email : '/cabinet/login'}>{t('newpass.login')}</NavLink>
			</React.Fragment>}
		</div>
	);
};

export default NewPass;
